import { Injectable, inject } from "@angular/core";
import { LG_LOCALIZATION_SETTINGS } from "@logex/framework/lg-localization";

import {
    IAuthenticationService,
    LG_USER_INFO,
    UserIdentity
} from "@logex/framework/lg-application";
import {
    SharedAppUser,
    SharedLocalizationSettingsService
} from "@mrdm-self-service-frontend/shared/util-logex-framework-setup";
import { firstValueFrom, tap } from "rxjs";

import { Auth0AuthorizationService } from "./auth0-authorization.service";
import { SharedAuthorizationApiService } from "libs/shared/data-access-authorization/src/lib/shared-authorization-api.service";

@Injectable()
export class Auth0AuthenticationService implements IAuthenticationService {
    private _auth0AuthorizationService = inject(Auth0AuthorizationService);
    private _localizationSettings = inject<SharedLocalizationSettingsService>(LG_LOCALIZATION_SETTINGS);
    private _authorizationApiService = inject(SharedAuthorizationApiService);
    private userInfo = inject<SharedAppUser>(LG_USER_INFO);

    get loggedIn(): boolean {
        return this._auth0AuthorizationService.loggedIn ?? false;
    }

    get user(): UserIdentity {
        const user = this._auth0AuthorizationService.currentUserProfile;
        return {
            id: user?.email ?? "",
            login: user?.email ?? "",
            name: user?.name ?? ""
        };
    }

    login(): Promise<boolean> {
        return this._auth0AuthorizationService.login("/", this._localizationSettings.loginLanguage);
    }

    isLoggedIn(): Promise<boolean> {
        return firstValueFrom(this._auth0AuthorizationService.isAuthenticated$);
    }

    logout(): Promise<void> {
        return this._auth0AuthorizationService.logout();
    }

    endImpersonation(): Promise<void> {
        return firstValueFrom(this._authorizationApiService.endImpersonation());
    }
}
